import { render, staticRenderFns } from "./business-organogram.vue?vue&type=template&id=20c29808"
import script from "./business-organogram.vue?vue&type=script&lang=js"
export * from "./business-organogram.vue?vue&type=script&lang=js"
import style0 from "./business-organogram.vue?vue&type=style&index=0&id=20c29808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports